import * as React from 'react';
import { IValue as ImportedValue, NewCampaignProvider } from './NewCampaignProvider';
import { ActionTypes, NewCampaignReducer } from './NewCampaignReducer';
import { ICombinedCampaign } from '../entities';

export type IValue = ImportedValue;

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export interface IConfiguredDispatcher {
  id: string;
  ownerId: string;
  dispatcher: string;
}

export type Dispatch = (action: IAction) => void;

export interface IState {
  combinedCampaign: ICombinedCampaign;
  stepValid: boolean;
  validSteps: number[];
  success?: boolean;
  createdCombinedCampaign?: ICombinedCampaign;
  error?: boolean;
  errorMessage?: string;
  loadingDispatchersData: boolean;
}

export const defaultContextValues: IState = {
  stepValid: false,
  createdCombinedCampaign: {
    campaign: {},
    offsiteCampaign: {
      state: 'TESTING',
      segments: [],
      suppressTimeWindows: [],
    },
  },
  validSteps: [],
  success: false,
  loadingDispatchersData: false,
  combinedCampaign: {
    campaign: {
      state: 'TESTING',
    },
    offsiteCampaign: {
      state: 'TESTING',
      segments: [],
      suppressTimeWindows: [],
    },
  },
};

export const NewCampaignStateContext = React.createContext<IState | undefined>(undefined);
export const NewCampaignDispatchContext = React.createContext<Dispatch | undefined>(undefined);

function useNewCampaignState() {
  const context = React.useContext(NewCampaignStateContext);
  if (context === undefined) {
    throw new Error('useNewCampaignState must be used within a NewCampaignProvider');
  }
  return context;
}

function useNewCampaignDispatch() {
  const context = React.useContext(NewCampaignDispatchContext);
  if (context === undefined) {
    throw new Error('UseNewCampaignDispatch must be used within a NewCampaignProvider');
  }
  return context;
}

export { NewCampaignProvider, NewCampaignReducer, useNewCampaignState, useNewCampaignDispatch };
